// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"1fa8c617","354":"892140df","420":"f22fa5c3","450":"f74a5b49","539":"6523970f","644":"809fe4ec","775":"cd75b432","857":"3f1eba90","884":"6440eae9","945":"47961620"}[chunkId] + ".js";
};